import Vue from "vue";
import Vuex from "vuex";

import { user } from "./user.module";
import { usuario } from "./usuario.module";
import { franquicia } from "./franquicia.module";
import { envio } from "./envio.module";
import { envios } from "./envios.module";
import { masivo } from "./masivo.module";
import { cliente } from "./cliente.module";
import { incidencia } from "./incidencia.module";
import { franquiciadora } from "./franquiciadora.module";
import { vistaOperativa } from ".//vistaOperativa.module";
import { notificacion } from "./notificacion.module";
import { parada } from "./parada.module";
import { partner } from "./partner.module";
import { servicios } from "./servicios.module";
import { puntoRed } from "./puntoRed.module";
import { libretaContacto } from "./libretaContacto.module";
import { rma } from "./rma.module";
import { estado } from "./estado.module";
import { vencimientos } from "./vencimientos.module";
import { formasPago } from "./formasPago.module";
import { tarifa } from "./tarifa.module";
import { valoracion } from "./valoracion.module";
import { planesCombustible } from "./planesCombustible.module";
import { estados } from "./estados.module";
import { estadosParadas } from "./estadosParadas.module";
import { extraviados } from "./extraviados.module";
import { fechaCierre } from "./fechaCierre.module";
import { errorCourier } from "./errorCourier.module";
import { apiKey } from "./apiKey.module";
import { ficherosSorter } from "./ficherosSorter.module";
import { plataforma } from "./plataformaIntegracion.module";
import { tarifaCliente } from "./tarifaCliente.module";
import { suplemento } from "./suplemento.module";
import { tarifaBase } from "./tarifaBase.module";
import { notificacionIntegracion } from "./integracion.module";
import { gestionConfig } from "./gestionConfiguracion.module";
import { evento } from "./eventosMobile.module";
import { geografico } from "./geografico.module";
import { transito } from "./transito.module";
import { geoname } from "./geoname.module";
import { servicioSeur } from "./serviciosSeur.module";
import { borrado } from "./borrados.module";
import { mobileQueue } from "./mobileQueue.module";
import { operativaVistas } from "./operativasControl.module";
import { repartidorEventos } from "./repartidores.module";
import { otrosMasivos } from "./otrosMasivos.module";
import { enviosAgrupados } from "./enviosAgrupados.module";
import { documentacion } from "./documentacion.module";
import { impuestos } from "./impuestos.module";
import { roles } from "./roles.module";
import { notificacionesDashboard } from "./notificacionesDashboard.module";
import { solucion } from "./soluciones.module";
import { solucionRegla } from "./solucionesReglas.module";
import { agrupacionesFranquicia } from "./agrupaciones.module";
import { geograficos } from "./geograficos.module";
import { palet } from "./palet.module";
import { almacen } from "./almacenes.module";
import { ubicacion } from "./ubicaciones.module";
import { medida } from "./medidas.module";
import { area } from "./areas.module";
import { paletHub } from "./paletHub.module";
import { tarifaPalet } from "./tarifaPalet.module";
import { tarifaGenerico } from "./tarifaGenerico.module";
import { expedienteMedida } from "./expedientesMedida.module";
import { expedienteServicio } from "./expedientesServicio.module";
import { incoterm } from "./incoterm.module";
import { expedienteSiniestro } from "./expedientesSiniestro.module";
import { storage } from "./storage.module";
import { incotermSended } from "./incotermSended.module";
import { ticketBai } from "./ticketBai.module";
import { clienteExcluido } from "./clienteExcluido.module";
import { chat } from "./chat.module";
import { seguroConfig } from "./seguroConfig.module";
import { procesos } from "./proceso.module";
import { whatsappTemplate } from "./whatsappTemplate.module";
import { whatsapp } from "./whatsapp.module";
Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    user,
    usuario,
    franquicia,
    envio,
    envios,
    masivo,
    cliente,
    incidencia,
    franquiciadora,
    vistaOperativa,
    notificacion,
    parada,
    partner,
    servicios,
    puntoRed,
    libretaContacto,
    rma,
    vencimientos,
    formasPago,
    tarifa,
    estado,
    valoracion,
    planesCombustible,
    estados,
    estadosParadas,
    extraviados,
    fechaCierre,
    errorCourier,
    apiKey,
    ficherosSorter,
    plataforma,
    tarifaCliente,
    suplemento,
    tarifaBase,
    notificacionIntegracion,
    geografico,
    gestionConfig,
    evento,
    transito,
    geoname,
    servicioSeur,
    borrado,
    mobileQueue,
    operativaVistas,
    repartidorEventos,
    otrosMasivos,
    enviosAgrupados,
    documentacion,
    impuestos,
    roles,
    notificacionesDashboard,
    solucion,
    solucionRegla,
    agrupacionesFranquicia,
    geograficos,
    palet,
    almacen,
    ubicacion,
    medida,
    area,
    paletHub,
    tarifaPalet,
    expedienteMedida,
    expedienteServicio,
    incoterm,
    expedienteSiniestro,
    storage,
    incotermSended,
    tarifaGenerico,
    ticketBai,
    clienteExcluido,
    chat,
    seguroConfig,
    procesos,
    whatsappTemplate,
    whatsapp,
  },
});
